import { Component } from "@angular/core";

@Component({
  selector: "pro-answers-table",
  templateUrl: "pro-answers-table.component.html"
})
export class ProAnswersTable {
  constructor() {}

}



// WEBPACK FOOTER //
// ./src/components/pro-answers-table.component/pro-answers-table.component.ts